export class DataProcessing {
  constructor(inputdata) {
    this.data = inputdata;
  }

  extractValuesByProperty(property_name) {
    const column_data = this.data.map((obj) => obj[property_name]);
    return {
      property_name,
      column_data,
    };
  }
  filterArray(disallowedValues, dataArray) {
    return dataArray.filter((value) => !disallowedValues.includes(value));
  }

  extractAllProperties() {
    // Extract headers
    const headers = this.data.map((row) => Object.keys(row));
    const uniqueHeaders = [...new Set(headers.flat())];

    return uniqueHeaders;
  }

  addDisregagrdedPropertiesToInputData() {
    const keys = this.extractAllProperties();
    const data = this.data;
    const newData = data.map((item) => {
      const newItem = { ...item };
      keys.forEach((key) => {
        if (!Object.prototype.hasOwnProperty.call(newItem, key)) {
          newItem[key] = null;
        }
      });
      return newItem;
    });
    return newData;
  }
}
